import React from "react";
import Footer from "../../components/Footer";
import Navigation from "../../components/Navigation";
import PagesLayout from "../PagesLayout";

const Layout = ({ children }) => {
  return (
    <>
      <Navigation />
      <PagesLayout>{children}</PagesLayout>
      <Footer />
    </>
  );
};

export default Layout;
